import styled from 'styled-components'

import { Container as Card } from '~/components/Card/styles'

export const Container = styled.article`
	min-height: 82vh;

	main {
		padding: 35px 100px;

		${Card} {
			display: grid;
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 36px auto auto auto;
			min-height: 70vh;

			> h1 {
				grid-column: 1/span 2;
				height: fit-content;
			}

			.table-container,
			.require-rotation,
			.spinner-container {
				grid-column: 1/3;
			}
		}

		@media(max-width: 1100px) {
			padding: 10px 0;
		}

		@media(max-width: 560px) {
			.button-cadastrar {
				display: none;
			}
		}
	}
`
